/** Dates belong to the actual visit shop, never the viewing browser or a guessed current shop. */
export function clientLastVisitText(value: {
  lastVisitAtUtc?: string | null;
  lastVisitTimeZone?: string | null;
  lastVisitLocationName?: string | null;
}): string {
  if (!value.lastVisitAtUtc || !value.lastVisitTimeZone) return "";
  const at = new Date(value.lastVisitAtUtc);
  if (Number.isNaN(at.getTime())) return "";
  try {
    const date = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: value.lastVisitTimeZone,
    }).format(at);
    return `Last in ${date}${value.lastVisitLocationName ? `, ${value.lastVisitLocationName}` : ""}`;
  } catch {
    return "";
  }
}
